export interface CCTipoDeDocumento {
    codigoTipoDocumento: any;
    nombre: any;
}

export class CCTipoDeDocumento implements CCTipoDeDocumento {
    constructor(init?: CCTiposDeDocumentosFormValues) {
        Object.assign(this, init);
    }
}

export class CCTiposDeDocumentosFormValues {
    codigoTipoDocumento: number = 0;
    nombre: string = "";

    constructor(CCTipoDeDocumento?: CCTiposDeDocumentosFormValues) {
        if (CCTipoDeDocumento) {
            this.codigoTipoDocumento = CCTipoDeDocumento.codigoTipoDocumento;
            this.nombre = CCTipoDeDocumento.nombre || '';
        }

    }
}